import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
`;

export const Track = styled.div`
    width: 260px;
    overflow: hidden;
    border-radius: 16px;
`;

export const Slide = styled.div`
    display: flex;
    transition: transform 0.35s ease;

    img {
        min-width: 260px;
        width: 260px;
        height: auto;
        object-fit: contain;
        border-radius: 16px;
    }
`;

export const ArrowButton = styled.button`
    position: absolute;
    top: 40%;
    background: rgba(0, 0, 0, 0.25);
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    cursor: pointer;
    padding: 0;
    display: grid;
    place-items: center;
    transition: opacity 0.2s;
    z-index: 1;

    svg {
        display: block;
        width: 22px;
        height: 22px;
        position: relative;
    }

    path {
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2.4;
    }

    &:first-child {
        left: calc(50% - 174px);

        svg {
            left: -1px;
        }
    }
    &:last-of-type {
        right: calc(50% - 174px);

        svg {
            left: 1px;
        }
    }
    &:disabled {
        opacity: 0.25;
        cursor: default;
    }
    &:not(:disabled):hover {
        background: rgba(0, 0, 0, 0.4);
    }
`;

export const Dots = styled.div`
    display: flex;
    gap: 8px;
`;

export const Dot = styled.span<{ $active: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $active }) => ($active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.4)')};
    cursor: pointer;
    transition: background 0.2s;
`;
